<template>
  <div class="my-order all-order-content public-content">
    <div class="breadcrumb">{{ task.name }}</div>
    <div class="right-content">
      <div class="main-content">
        <div class="myorder-content">
          <!--      查询订单-->
          <div class="check-menu">
            <el-form :inline="true" :model="form" label-width="70px" style="margin:20px 0 0 20px" class="demo-form-inline">
              <el-row>
                <el-col :span="5">
                  <el-form-item label="下载状态">
                    <el-select clearable v-model="form.downloadStatus" filterable placeholder="">
                      <el-option label="未下载" value="NOT_DOWNLOAD"></el-option>
                      <el-option label="已下载" value="DONE_DOWNLOAD"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="备注">
                    <el-input v-model="form.username" clearable placeholder=""></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <span style="display: inline-block;height: 30px;line-height: 30px;"> 收片人数：{{ task.collNum + '/' + task.limitPerson }} </span>
                </el-col>
                <el-col :span="6" class="el-refer">
                  <el-button round @click="onSubmit()">查询</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div class="myorder-table" style="padding:0 10px;">
          <el-table border class="table-cell" :data="tableList">
            <el-table-column prop="username" label="备注" width="200px"></el-table-column>
            <el-table-column prop="userCreated" label="照片">
              <template slot-scope="scope">
                <div v-if="scope.row.customerImages.length !== 0" style="display: flex;align-items: center;justify-content: center;">
                  <el-image v-if="scope.row.customerImages.length >= 1" style="width: 85px; height: 85px;border-radius:7px;border:1px solid #000;margin-right:3px;"
                    :src="scope.row.customerImages[0].image.url + '?x-sds-process=image/resize,l_83,m_mfit'" fit="contain"></el-image>
                  <el-image v-if="scope.row.customerImages.length >= 2" style="width: 85px; height: 85px;border-radius:7px;border:1px solid #000;margin-right:3px;"
                    :src="scope.row.customerImages[1].image.url + '?x-sds-process=image/resize,l_83,m_mfit'" fit="contain"></el-image>
                  <el-image v-if="scope.row.customerImages.length >= 3" style="width: 85px; height: 85px;border-radius:7px;border:1px solid #000;margin-right:3px;"
                    :src="scope.row.customerImages[2].image.url + '?x-sds-process=image/resize,l_83,m_mfit'" fit="contain"></el-image>
                  <div v-if="scope.row.customerImages.length >= 3" style="font-size:25px;">...</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="downloadStatus" label="下载状态">
              <template slot-scope="scope">
                <span v-if="scope.row.downloadStatus === 'DONE_DOWNLOAD'">已下载</span>
                <span v-if="scope.row.downloadStatus === 'NOT_DOWNLOAD'">未下载</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="110px">
              <template slot-scope="scope">
                <span class="action_btn" @click="$router.push({ path: '/pickColl/Customer', query: { info: JSON.stringify(scope.row) } })">详情</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination @changePage="changePage" :queryInfo="queryInfo"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/Pagination/index.vue'
import { adminTaskDetail, adminCustomerPage } from '@/api/auxx.js'

export default {
  name: 'my-order',
  components: {
    pagination
  },
  data () {
    return {
      percentage: 0,
      dialogVisible: true,
      downloadType: '',
      downloadDialog: false,
      endDialog: false,
      selected: [],
      deleteItem: null,
      deleteDialog: false,
      form: {
        username: '',
        downloadStatus: '',
        taskId: this.$route.query.id
      },
      tableList: [],
      task: {},
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      imgUrl: ''
    }
  },
  watch: {

  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getTask()
    this.onSubmit()
  },
  methods: {
    onSubmit () {
      let form = JSON.parse(JSON.stringify(this.form))
      Object.keys(form).forEach(key => !form[key] && delete form[key])
      adminCustomerPage({
        data: form,
        params: {
          page: this.queryInfo.pageNum - 1,
          size: this.queryInfo.pageSize
        }
      })
        .then(res => {
          if (res.data.success) {
            this.tableList = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    getTask () {
      adminTaskDetail(this.$route.query.id)
        .then(res => {
          if (res.data.success) {
            this.task = res.data.data
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";

.title {
  span {
    margin-left: 24px;
    font-size: 14px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #707070;
  }
}

.action_btn {
  display: block;
  width: 89px;
  height: 22px;
  border-radius: 22px;
  background: #f2f2f2;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-family: Source Han Sans CN, Source Han Sans CN-Light;
  font-weight: 300;
  text-align: center;
  color: #2e7cd4;
  margin: 5px auto;
  cursor: pointer;
}

.single_img {
  width: 85px;
  height: 85px;
}

.function {
  background-color: #fafafa;
}

.btn {
  background-color: #f2f2f2;
  display: inline-block;
  // width: 146px;
  padding: 0 15px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  background: #ffffff;
  border: 2px solid #2a2a2a;
  border-radius: 21px;
  font-size: 16px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  color: #2a2a2a;
  margin: 5px;
  cursor: pointer;
}

.remark {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
  font-weight: 400;
  color: #707070;
}

@{deep} .download .el-dialog__footer {
  text-align: center;
}
</style>
